/* ============================================================
   story-module-sg-scrolly.js — sg-scrolly-Szenen-Modul (AP-A)
   Format „Sperrgebiet" (sg). Steuert .sg-scrolly-Panels
   (data-story-type="custom-sg-scrolly"): eine klebende Medien-Stage
   (Foto ODER Video ODER Crossfade-Paar), durchscrollende Text-Tafeln
   mit Wort-Reveal PRO TAFEL, ein O-Ton (panel-audio, unverändert).

   FORK von story-module-nbscrolly.js (Nadelöhr) — bewusst NICHT
   .nb-scrolly wiederverwendet (Nebenwirkungen: kapert PanelAudio.init,
   baut eigenen Home-Button, siehe FORMAT-REFERENZ.html §1 Namensraum-
   Regel + implementation-sperrgebiet.html V2). Eigener Namensraum:
   nur .sg-scrolly / data-sg-*.

   Self-Guard: tut nichts, wenn keine .sg-scrolly-Panels da sind
   → auf allen anderen Stories (Nadelöhr, Beendorf) komplett inert.

   Blöcke:
     0  Wort-Reveal entkoppeln (defensiv: data-reveal-words wegnehmen,
        damit das globale Modul sg-Tafeln nicht panel-weit auslöst)
     1  Single-Winner Medien-Stage (Foto/Video, Container-Switch)
     2  Hintergrund-Stage (Farbe ODER Bild, §3a)
     3  Reveal pro Tafel, Stil je Tafel: "highlight" (CSS-Fade + .sg-hl-Wisch,
        Default) ODER "words" (Wort-für-Wort via word-reveal-Modul) — AP-A.2

   NICHT hier: der optionale BG-Bild-Crossfade-Scrub (§4) — der ist in
   story-module-sperrgebiet.js Abschnitt 7 generalisiert (bestehender
   .sg-crossfade-Scrub erweitert um .sg-scrolly__media--crossfade),
   damit die --cf-Logik nicht dupliziert wird. Home-Button
   (.sg-scrolly__home[data-sg-goto-hub]) ebenfalls kein Neu-Code: bindet
   automatisch an story-module-sperrgebiet.js Abschnitt 3 (scannt das
   ganze Dokument nach [data-sg-goto-hub]). Atmo/Mute-Kohärenz ist AP-C,
   nicht Teil dieses Moduls.

   Markup-Vertrag: ghost-templates/SPERRGEBIET/FORMAT-REFERENZ.html §3.
   ============================================================ */
(function () {
  'use strict';

  // Self-Guard: nur auf sg-scrolly-Szenen aktiv werden.
  if (!document.querySelector('.sg-scrolly')) return;

  var DEBUG = window.location.search.indexOf('debug=story') !== -1;
  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[sg-scrolly]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  /* ───────── Block 0 — Wort-Reveal PRO TAFEL entkoppeln (V3) ─────────
     story-module-word-reveal.js hört global auf story:panel:activated und
     reveal't dabei ALLE [data-reveal-words]-Elemente des Panels auf einmal
     (Panel-weites Default-Verhalten). sg-scrolly braucht Tafel-für-Tafel,
     synchron zum Scrollen durch die hohe Szene. Fix: das Trigger-Attribut
     hier SOFORT entfernen (dieses Script läuft — wie word-reveal.js selbst
     — als deferred Script vor jedem scroll-getriebenen Event; die Document-
     Parsing ist zu diesem Zeitpunkt abgeschlossen), damit der globale Hook
     bei sg-Tafeln nichts mehr findet. Die eigentliche Reveal-Funktion
     (revealElement(), s. Block 3) bleibt nutzbar — sie hängt NICHT am
     Attribut, sondern wird direkt aufgerufen. */
  Array.prototype.forEach.call(
    document.querySelectorAll('.sg-scrolly__quote-text[data-reveal-words]'),
    function (el) {
      el.removeAttribute('data-reveal-words');
      el.dataset.sgRevealWords = '1';   // Marker, rein informativ (Debug)
    }
  );

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var scenes = Array.prototype.slice.call(document.querySelectorAll('.sg-scrolly'));
    if (!scenes.length) return;

    /* Vollflächen-Blende (Claude-Chrome-Sichtung 2026-08-18): Während eines
       StoryAPI.fadeTo (Wrapper 250 ms aus → Sprung → 250 ms ein) ist die
       Ziel-Szene für Block 1/2 der „erzwungene Gewinner" — Bühne + Farbe werden
       im Dunkel vorbereitet, damit Text UND Medium gemeinsam mit dem Wrapper
       einblenden (vorher: Text sofort, Medium erst ~1,3 s später, Farbe getrennt).
       Gilt für alle sg-Touren (Sperrgebiet, Spurensuche). */
    var sgForcedWinner = null;
    var SG_NONE = { none: true };   // Sentinel: Ziel ist KEINE Szene (Hub/Pano) → Bühne leer erzwingen
    var sgForcedTimer = null;
    function sgSetForced(target) {
      sgForcedWinner = target || null;
      if (sgForcedTimer) clearTimeout(sgForcedTimer);
      if (target) sgForcedTimer = setTimeout(function () { sgForcedWinner = null; }, 3000); // Failsafe
    }
    document.addEventListener('story:panel:activated', function () {
      // Theme hat das Ziel (oder ein anderes Panel) aktiviert → normale Wahl übernimmt wieder
      if (sgForcedWinner) sgSetForced(null);
    });

    /* ============================================================
       Block 1 — Single-Winner Medien-Stage (Foto/Video)
       Fork von nb Block 1 (story-module-nbscrolly.js): NIE zwei Medien
       gleichzeitig sichtbar. Schaltet den CONTAINER (.sg-scrolly__media),
       null-safe für <img> (kein <video>-Zugriff, wenn keins da ist).
       Vereinfacht gegenüber nb: kein Delay-Choreo/Audio-Kopplung nötig —
       der O-Ton läuft unabhängig über panel-audio + MediaManager bei
       story:panel:activated (V4), kein Neu-Code dafür. Video ist laut
       Vertrag ohnehin muted → kein Audio-Doppel-Risiko beim Crossfade.
       ============================================================ */
    (function () {
      var COMMIT_DEBOUNCE_MS = 120;   // entprellt Gewinner-Wechsel (Fork nb)
      var visible = new Set();
      var currentWinner = null;
      var commitTimer = null;

      function mediaOf(scn) { return scn.querySelector('.sg-scrolly__media'); }

      // Aktives Panel = vom Theme markiertes .is-active (active-panel.js,
      // ratio≥0.5 bzw. Viewport-Abdeckung bei hohen Panels) — EINE gemeinsame
      // Quelle für Medium/BG/Text/Audio. Fallback (höchster sichtbarer
      // DOM-Index) nur, solange das Theme noch kein is-active gesetzt hat.
      function pickWinner() {
        if (sgForcedWinner) return (sgForcedWinner !== SG_NONE && scenes.indexOf(sgForcedWinner) !== -1) ? sgForcedWinner : null;
        var act = document.querySelector('.sg-scrolly.story-panel.is-active');
        if (act) return act;
        // AP-B-Fix (2026-07-22): Hat das Theme ein aktives Panel, das KEINE
        // sg-Szene ist (Pano-Hub, Galerie, Intro-Tafel), gewinnt NIEMAND.
        // Sonst bleibt die fixe Medien-Bühne einer am Viewport-Rand nur
        // angeschnittenen Szene als Vollbild-Overlay stehen und verdeckt
        // z. B. den Pano-Hub (Kanten-Berührung zählt im Observer als
        // sichtbar). Der Index-Fallback unten gilt — wie ursprünglich
        // dokumentiert — nur für den Bootstrap, solange active-panel.js
        // noch kein is-active gesetzt hat.
        if (window.storyActivePanel) return null;
        if (visible.size === 0) return null;
        var chosen = null, max = -1;
        visible.forEach(function (p) {
          var i = scenes.indexOf(p);
          if (i > max) { max = i; chosen = p; }
        });
        return chosen;
      }

      // WebKit/Safari (B-1, 2026-07-25): muted/playsInline müssen als PROPERTY
      // (nicht nur als HTML-Attribut) vor play() gesetzt sein, sonst blockt
      // Desktop-Safari den Autostart außerhalb des Gesten-Stacks. Und der
      // play()-Reject wird nicht mehr still geschluckt: NotAllowedError laut
      // melden (ungated → im Safari-Web-Inspector sichtbar), damit man weiß,
      // WARUM das Video steht. Erwartbare Rejects (AbortError beim schnellen
      // Wegscrollen) bleiben stumm.
      function playMuted(vid) {
        try { vid.muted = true; vid.playsInline = true; } catch (e) {}
        var p = vid.play && vid.play();
        if (p && p.catch) p.catch(function (err) {
          if (err && err.name === 'NotAllowedError' && window.console) {
            console.warn('[sg-scrolly] video.play() blockiert (NotAllowedError) —', err.message);
          }
        });
      }

      /* ── Spurensuche E1/E2 (Opt-in, 2026-08-18) ────────────────────
         data-sg-video-sound="1": das Szenen-Video läuft MIT Ton (Interview-
         Videos, Untertitel im Bild). Bewusst NICHT ans Video-Autoplay-Modul
         delegiert: die fixe Medien-Stage (visibility:hidden) täuscht dessen
         IntersectionObserver — alle Szenen-Videos wären „sichtbar". Block 1
         spielt deshalb selbst und koordiniert über den MediaManager
         (Single-Medium, Atmo-Ducking). Rückkehr: pause() behält die
         Position → läuft weiter; nach `ended` startet play() von 0.
         data-sg-once="1": kein Loop; `ended` → .is-ended (CSS blendet die
         Stage aus) + „Nochmal"-Knopf (Klick = Geste → Ton erlaubt).
         iOS: play() innerhalb einer Nutzer-Geste „segnet" das Element —
         Segnung in der Start-Geste (unlockAudio via MediaManager) für die
         erste Sound-Szene und beim Pin-/Marker-Klick für das Zielkapitel.
         Ohne Attribute: exakt das bisherige (stumme) Verhalten.        */
      function isSound(scn) { return !!scn && scn.getAttribute('data-sg-video-sound') === '1'; }
      function isOnce(scn)  { return !!scn && scn.getAttribute('data-sg-once') === '1'; }
      var mm = window.StoryMediaManager;
      var hasSoundScenes = scenes.some(isSound);

      var soundAdapter = {
        name: 'sg-scrolly-video-sound', type: 'video',
        isPlaying: false, panel: null, element: null,
        init: function () {}, start: function () {},
        pause: function () {
          if (this.element) { try { this.element.pause(); } catch (e) {} }
          this.isPlaying = false;
        },
        stop: function () { this.pause(); },
        cleanup: function () { this.pause(); },
        // Start-Geste („Tour starten"): erste Sound-Szene segnen (iOS)
        unlockAudio: function () {
          var first = scenes.filter(isSound)[0];
          if (first) blessScenes([first]);
        }
      };
      if (hasSoundScenes && mm && typeof mm.register === 'function') {
        try { mm.register(soundAdapter); } catch (e) {}
      }

      // Poster-Vorwärmen (Sichtung 2026-08-18: Medienseite „ploppte" nach):
      // Poster der Zielszenen schon in der Geste in den Browser-Cache holen.
      function warmPosters(scns) {
        scns.forEach(function (scn) {
          var m = mediaOf(scn), v = m && m.querySelector('video');
          var src = v && v.getAttribute('poster');
          if (src && !v._sgPosterWarm) { v._sgPosterWarm = true; var im = new Image(); im.src = src; }
        });
      }

      function blessScenes(scns) {
        warmPosters(scns);
        scns.forEach(function (scn) {
          var m = mediaOf(scn), v = m && m.querySelector('video');
          if (!v) return;
          try {
            v.playsInline = true;
            if (scn === currentWinner && !v.paused) {
              v.muted = false;             // läuft schon (stumm gestartet) → in der Geste Ton an
              return;
            }
            if (v._sgBlessed) return;
            v._sgBlessed = true;
            v.muted = false; v.muted = true; // Audio-Freigabe in der Geste merken, aber stumm anspielen (kein Blip)
            var p = v.play();
            if (p && p.then) {
              p.then(function () {
                if (scn !== currentWinner) { try { v.pause(); v.currentTime = 0; } catch (e) {} }
              }).catch(function () { v._sgBlessed = false; });
            }
          } catch (e) { v._sgBlessed = false; }
        });
      }

      // Pin-/Marker-Klick (Capture, vor fadeTo): Sound-Videos des Zielkapitels segnen.
      if (hasSoundScenes) {
        document.addEventListener('click', function (e) {
          var t = e.target && e.target.closest && (e.target.closest('[data-sg-goto]') || e.target.closest('.pano-hotspot[data-target-chapter]'));
          if (!t) return;
          var id = t.getAttribute('data-sg-goto') || t.getAttribute('data-target-chapter');
          if (!id) return;
          warmPosters(scenes.filter(function (s) { return s.getAttribute('data-sg-chapter') === id; }));
          blessScenes(scenes.filter(function (s) { return isSound(s) && s.getAttribute('data-sg-chapter') === id; }));
        }, true);
      }

      function playSound(scn, vid) {
        try { vid.playsInline = true; } catch (e) {}
        if (isOnce(scn)) { try { vid.loop = false; vid.removeAttribute('loop'); } catch (e) {} }
        soundAdapter.panel = scn; soundAdapter.element = vid;
        if (mm && typeof mm.requestPlay === 'function') {
          try { mm.requestPlay(soundAdapter); } catch (e) {}
        }
        var wantSound = !mm || mm.userGestureReceived;
        try { vid.muted = !wantSound; } catch (e) {}
        soundAdapter.isPlaying = true;
        var p = vid.play && vid.play();
        if (p && p.catch) p.catch(function (err) {
          if (err && err.name === 'NotAllowedError') {
            if (window.console) console.warn('[sg-scrolly] Ton-Autostart blockiert (NotAllowedError) — Fallback stumm:', err.message);
            playMuted(vid);
          }
        });
      }

      function stopSound(vid) {
        soundAdapter.isPlaying = false;
        if (mm && soundAdapter.element === vid && typeof mm.notifyStop === 'function') {
          try { mm.notifyStop(soundAdapter); } catch (e) {}
        }
      }

      function bindOnce(scn, vid) {
        if (vid._sgOnceBound) return;
        vid._sgOnceBound = true;
        vid.addEventListener('ended', function () {
          scn.classList.add('is-ended');
          if (isSound(scn)) stopSound(vid);
        });
        vid.addEventListener('play', function () { scn.classList.remove('is-ended'); });
        var btn = scn.querySelector('.sg-scrolly__replay');
        if (!btn) {
          btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sg-scrolly__replay';
          var lbl = scn.getAttribute('data-sg-replay-label') || 'Nochmal ansehen';
          btn.setAttribute('aria-label', lbl); btn.title = lbl;
          btn.textContent = '\u21BB';   // ↻ — Icon-Knopf mittig auf der Bühne (Sichtung 2026-08-18)
          scn.appendChild(btn);
        }
        if (!btn._sgBound) {
          btn._sgBound = true;
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            scn.classList.remove('is-ended');   // sofort (nicht erst am play-Event)
            try { vid.currentTime = 0; } catch (e2) {}
            if (isSound(scn)) playSound(scn, vid); else playMuted(vid);
          });
        }
      }

      function setActive(scn, active) {
        var m = mediaOf(scn);
        if (!m) return;
        m.classList.toggle('is-active', active);
        scn.classList.toggle('is-stage-active', active);   // E2: Replay-Knopf nur bei aktiver Bühne
        var vid = m.querySelector('video');
        if (!vid) return;   // Foto-Szene / Crossfade-Paar ohne <video>
        if (isOnce(scn)) bindOnce(scn, vid);
        if (active) {
          if (isSound(scn)) {
            playSound(scn, vid);             // E1: Position behalten (Weiterlaufen)
          } else {
            try { vid.currentTime = 0; } catch (e) {}
            playMuted(vid);
          }
          // Safari/langsames Netz (Sichtung 2026-07-23): Ist beim Play noch
          // nichts gepuffert (preload=none + träger Server), bleibt das
          // Video stehen — beim ersten canplay nachstarten, sofern die
          // Szene noch die aktive ist (und das Video nicht regulär zu Ende ist).
          if (!vid._sgRetryBound) {
            vid._sgRetryBound = true;
            vid.addEventListener('canplay', function () {
              var scnEl = vid.closest('.sg-scrolly');
              if (scnEl === currentWinner && vid.paused && !vid.ended) {
                if (isSound(scnEl)) playSound(scnEl, vid); else playMuted(vid);
              }
            });
          }
        } else if (vid.pause) {
          try { vid.pause(); } catch (e) {}
          if (isSound(scn)) stopSound(vid);
        }
      }

      // Grenz-Entprellung (Sichtung 2026-07-23): an der 50/50-Panelgrenze
      // (z. B. Szene ↔ Galerie) kippt is-active bei kleinen Scroll-Pendeln
      // mehrfach — jede Kippe zündete die 700ms-Foto-Blende → sichtbares
      // Flackern. Ein neuer Gewinner muss deshalb WINNER_HOLD_MS stabil
      // bleiben, bevor die Stage umschaltet.
      var WINNER_HOLD_MS = 250;
      // WICHTIG: undefined = „keine Bestätigung offen" — null ist ein
      // GÜLTIGER Gewinner-Wert (kein Szenen-Panel aktiv, z. B. am Hub).
      // Mit null als Leer-Sentinel wurde der Wechsel Szene→null nie
      // geplant und die Bühne blieb am Hub stehen (Sichtung 2026-07-23:
      // Intro-Video überdeckte das halbe Panorama).
      var pendingWinner;
      var pendingTimer = null;

      function switchTo(winner) {
        if (currentWinner) setActive(currentWinner, false);
        currentWinner = winner;
        if (winner) setActive(winner, true);
        log('Medien-Wechsel:', winner);
      }

      function commit() {
        var winner = pickWinner();
        if (winner === currentWinner) {
          pendingWinner = undefined;
          if (pendingTimer) { clearTimeout(pendingTimer); pendingTimer = null; }
          return;
        }
        if (pendingTimer && winner === pendingWinner) return; // Bestätigung läuft schon
        pendingWinner = winner;
        if (pendingTimer) clearTimeout(pendingTimer);
        pendingTimer = setTimeout(function () {
          pendingTimer = null;
          var confirmed = pendingWinner;
          pendingWinner = undefined;
          if (confirmed !== currentWinner && pickWinner() === confirmed) {
            switchTo(confirmed);
          }
        }, WINNER_HOLD_MS);
      }

      function scheduleCommit() {
        if (commitTimer) clearTimeout(commitTimer);
        commitTimer = setTimeout(commit, COMMIT_DEBOUNCE_MS);
      }

      /* Medien-Bereitschaft (Sichtung 2026-08-18: Bild/Video „poppte" nach dem
         Laden in die schon sichtbare Bühne): das Medium selbst startet unsichtbar
         (CSS: opacity 0) und wird mit .is-ready weich eingeblendet — Bild: geladen;
         Video: Poster geladen ODER erste Daten da. Sperrgebiet-Fotos profitieren mit. */
      function markReady(el) { if (el && !el.classList.contains('is-ready')) el.classList.add('is-ready'); }
      scenes.forEach(function (scn) {
        var m = mediaOf(scn); if (!m) return;
        Array.prototype.forEach.call(m.querySelectorAll(':scope > img'), function (img) {
          if (img.complete && img.naturalWidth) markReady(img);
          else { img.addEventListener('load', function () { markReady(img); }); img.addEventListener('error', function () { markReady(img); }); }
        });
        Array.prototype.forEach.call(m.querySelectorAll(':scope > video'), function (v) {
          var poster = v.getAttribute('poster');
          if (poster) {
            var pi = new Image();
            pi.onload = function () { markReady(v); };
            pi.onerror = function () { markReady(v); };
            pi.src = poster;
            v._sgPosterWarm = true;
          }
          ['loadeddata', 'canplay', 'error'].forEach(function (ev) { v.addEventListener(ev, function () { markReady(v); }); });
          if (!poster && v.readyState >= 2) markReady(v);
          if (!poster) setTimeout(function () { markReady(v); }, 4000); // Failsafe ohne Poster
        });
      });

      // Autoplay neutralisieren (Fork nb): alle Videos einmal stoppen und
      // auf 0 setzen, damit nur das gewinnende Szenen-Video läuft.
      // Vorpuffern (Sichtung 2026-07-23): das Video der ERSTEN Szene
      // (Intro) darf sofort laden — der Nutzer landet direkt davor;
      // preload=none + träger Server hieße sonst Standbild.
      scenes.forEach(function (scn, idx) {
        var m = mediaOf(scn), v = m && m.querySelector('video');
        if (v) {
          try { v.removeAttribute('autoplay'); v.pause(); v.currentTime = 0; } catch (e) {}
          if (idx === 0) { try { v.preload = 'auto'; v.load(); } catch (e2) {} }
        }
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target);
        });
        scheduleCommit();
      }, { threshold: 0, rootMargin: '0px' });
      scenes.forEach(function (p) { observer.observe(p); });

      // Auch auf den Theme-Panelwechsel committen — synchron zu is-active.
      window.addEventListener('story:panel:activated', scheduleCommit);

      /* Vollflächen-Blende: fadeTo-Hook. StoryAPI.fadeTo wird umhüllt (nur auf
         sg-Seiten, self-guarded): Ziel merken, nach der Ausblendung (~260 ms) die
         Bühne ohne Übergang auf die Ziel-Szene schalten (oder abräumen, wenn das
         Ziel keine Szene ist — z. B. Hub/Pano), Farbe via sg:preswitch (Block 2). */
      function preSwitch(target) {
        var els = scenes.map(mediaOf).filter(Boolean);
        els.forEach(function (m) { m.style.transition = 'none'; });
        if (pendingTimer) { clearTimeout(pendingTimer); pendingTimer = null; }
        pendingWinner = undefined;
        if (target !== currentWinner) switchTo(target);
        void document.body.offsetHeight;
        els.forEach(function (m) { m.style.transition = ''; });
        document.dispatchEvent(new CustomEvent('sg:preswitch', { detail: { target: target } }));
        log('Vollflächen-Blende: Ziel vorbereitet', target);
      }
      function installFadeHook() {
        var api = window.StoryAPI;
        if (!api || typeof api.fadeTo !== 'function' || api._sgFadeHooked) return !!(api && api._sgFadeHooked);
        var orig = api.fadeTo;
        api.fadeTo = function (index) {
          var panels = typeof api.getPanels === 'function' ? api.getPanels() : [];
          var target = panels[index] || null;
          var isScene = !!(target && target.classList && target.classList.contains('sg-scrolly'));
          sgSetForced(isScene ? target : SG_NONE);
          setTimeout(function () { preSwitch(isScene ? target : null); }, 260);
          return orig.apply(this, arguments);
        };
        api._sgFadeHooked = true;
        return true;
      }
      if (!installFadeHook()) {
        var hookTries = 0;
        var hookTimer = setInterval(function () {
          if (installFadeHook() || ++hookTries > 50) clearInterval(hookTimer);
        }, 100);
      }
    })();

    /* ============================================================
       Block 2 — Hintergrund-Stage: Farbe ODER Bild (§3a)
       Fork von nb Block 2 (.nb-scrolly__bg-stage), erweitert um die
       Bild-Option. Ein globaler, geteilter Fixed-Layer HINTER der
       Medien-Stage. data-sg-bg-image gewinnt, falls gesetzt.
       ============================================================ */
    (function () {
      function hexToRgb(hex) {
        var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
        if (!m) return null;
        return { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) };
      }

      if (document.querySelector('.sg-scrolly__bg-stage')) return;
      var stage = document.createElement('div');
      stage.className = 'sg-scrolly__bg-stage';
      var imgLayer = document.createElement('div');
      imgLayer.className = 'sg-scrolly__bg-stage-image';
      stage.appendChild(imgLayer);
      document.body.insertBefore(stage, document.body.firstChild);

      var visibleScenes = new Set();

      function apply(scn) {
        if (!scn) return;
        var bgImage = scn.getAttribute('data-sg-bg-image');
        var bgColor = scn.getAttribute('data-sg-bg');

        if (bgImage) {
          imgLayer.style.backgroundImage = 'url("' + bgImage + '")';
          imgLayer.classList.add('is-active');
        } else {
          imgLayer.classList.remove('is-active');
        }

        if (bgColor) {
          stage.style.backgroundColor = bgColor;
          var rgb = hexToRgb(bgColor);
          if (rgb) {
            document.documentElement.style.setProperty(
              '--sg-scrolly-text-bg',
              'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.4)'
            );
          }
        } else if (!bgImage) {
          stage.style.backgroundColor = 'transparent';
        }
      }

      function updateBg() {
        var chosen = (sgForcedWinner && sgForcedWinner !== SG_NONE) ? sgForcedWinner : document.querySelector('.sg-scrolly.story-panel.is-active');
        if (!chosen) {
          if (visibleScenes.size === 0) return;
          var maxIdx = -1;
          visibleScenes.forEach(function (scn) {
            var idx = scenes.indexOf(scn);
            if (idx > maxIdx) { maxIdx = idx; chosen = scn; }
          });
        }
        apply(chosen);
      }

      var bgObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visibleScenes.add(e.target); else visibleScenes.delete(e.target);
        });
        updateBg();
      }, { threshold: 0, rootMargin: '0px' });
      scenes.forEach(function (scn) { bgObserver.observe(scn); });
      document.addEventListener('sg:preswitch', updateBg);   // Vollflächen-Blende: Farbe im Dunkel setzen
      updateBg();

      window.addEventListener('story:panel:activated', updateBg);
    })();

    /* ============================================================
       Block 3 — Reveal PRO TAFEL, Stil je Tafel (AP-A.2)
       data-sg-reveal am .sg-scrolly__quote wählt den Stil:
         "highlight" (Default): der ganze Block fadet ein, .sg-hl wischt die
                     Farbe hinein — reines CSS (.is-revealed am Text). Braucht
                     KEIN Wort-Reveal-Modul (Fallback-fest, gewünschter Stil).
         "words":    Wort-für-Wort über story-module-word-reveal.js
                     (revealElement). Fehlt das Modul → Fallback auf highlight.
       Getriggert wird auf .sg-scrolly__quote-inner (klebt, 100vh → Ratio
       erreicht die Schwelle zuverlässig; der hohe Dwell-Wrapper selbst
       käme bei großer Verweildauer nie über 0.6). Einmalig pro Tafel.
       ============================================================ */
    (function () {
      var inners = Array.prototype.slice.call(document.querySelectorAll('.sg-scrolly__quote-inner'));
      if (!inners.length) return;

      var hasWordReveal = window.StoryModuleWordReveal &&
        typeof window.StoryModuleWordReveal.revealElement === 'function';

      function revealQuote(quote) {
        var textEl = quote.querySelector('.sg-scrolly__quote-text');
        if (!textEl) return;
        var mode = quote.getAttribute('data-sg-reveal') || 'highlight';
        if (mode === 'words' && hasWordReveal) {
          window.StoryModuleWordReveal.revealElement(textEl);
        } else {
          textEl.classList.add('is-revealed');   // CSS: Block-Fade + .sg-hl-Wisch
        }
        log('Tafel enthüllt (' + mode + '):', textEl.textContent.slice(0, 40) + '…');
      }

      /* Sichtung 2026-07-22: NICHT die Inner beobachten — unter Scroll-
         Timelines sind sie position:fixed und damit für den Observer
         IMMER sichtbar → alle Highlights zündeten sofort beim Szenen-
         Einstieg. Stattdessen den Tafel-BLOCK (im Fluss) beobachten,
         Mittelband des Viewports: der Reveal kommt erst, wenn die Tafel
         sich Richtung Halt bewegt (nb-Timing). */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var quote = entry.target.closest('.sg-scrolly__quote') || entry.target.parentNode;
          if (quote) revealQuote(quote);
          io.unobserve(entry.target);   // einmalig pro Tafel
        });
      }, { threshold: 0, rootMargin: '-38% 0px -38% 0px' });

      inners.forEach(function (el) {
        var quote = el.closest('.sg-scrolly__quote');
        io.observe(quote || el);
      });
    })();

    /* ── Kontrast-Klasse (Davids Sichtung 2026-07-22): Tafeln nutzen dunkle
       Schrift auf hellem Glas — auf dunklen Farbflächen (data-sg-bg) säuft
       das ab. Dunkle Hintergründe bekommen sg-scrolly--dark-bg → helle
       Schrift auf dunklem Glas (CSS). Hintergrund-BILDER bleiben beim
       hellen Glas (Foto dahinter). ── */
    (function () {
      scenes.forEach(function (scn) {
        if (scn.getAttribute('data-sg-bg-image')) return;
        var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(scn.getAttribute('data-sg-bg') || '');
        if (!m) return;
        var lum = 0.2126 * parseInt(m[1], 16) + 0.7152 * parseInt(m[2], 16) + 0.0722 * parseInt(m[3], 16);
        if (lum < 100) scn.classList.add('sg-scrolly--dark-bg');
      });
    })();

    log('sg-scrolly initialisiert:', { szenen: scenes.length });
  });
})();
